import { BUY_PACKAGES, FETCH_PACKAGES, VERIFY_PACKAGES } from "../constants/packages";
import { PackageDuration, PackageTypes } from "../types";

export function fetchPackages(doctorId: number) {
  return {
    type: FETCH_PACKAGES,
    api: true,
    payload: {
      method: "GET",
      url: `/package/${doctorId}`,
    },
    data: { assessmentId: doctorId },
  };
}

export function checkoutPackages(doctorId: number, packageType: PackageTypes, packageDuration: PackageDuration) {
  return {
    type: BUY_PACKAGES,
    api: true,
    payload: {
      method: "POST",
      url: `/package/${doctorId}/checkout`,
      data: { packageType, packageDuration },
    },
  };
}

export function verfiyPackagePayment(orderId: number, trackId: number) {
  return {
    type: VERIFY_PACKAGES,
    api: true,
    payload: {
      method: "GET",
      url: `/package/verify`,
      params: { orderId, trackId },
    },
  };
}
